import React, {Component} from 'react'
import FJModal from "fj-modal";
import styles from './FJCommonModal.module.less';
import FJClose from '../../../common/component/FJClose/FJClose';
import FJButtonCircleIcon from "../button-circle-icon/FJButtonCircleIcon";
import closeSvg from "../../../icon/close.svg";
import key from 'keymaster';
import classNames from 'classnames';

function ModalClose(props) {
  let {
    onClick
  } = props;
  return (
    <div className={styles.close} onClick={onClick}>
      <FJClose />
    </div>
  );
}

function ModalInnerClose(props) {
  let {
    onClick
  } = props;
  return (
    <div className={styles.close_inner}>
      <FJButtonCircleIcon icon={closeSvg} onClick={onClick} />
    </div>
  );
}

class FJCommonModal extends Component {


  onHide = () => {
    key.setScope('default');
    if (this.props.onHide) {
      this.props.onHide();
    }
  };

  onShow = () => {
    key.setScope('');
    if (this.props.onShow) {
      this.props.onShow();
    }
  };

  render() {
    let {
      onCancel,
      onShown,
      onHidden,
      title,
      hasOuterCloseBtn,
      hasInnerCloseBtn,
      hasInnerTitle,
      hasOuterTitle,
      visible,
      width,
	    zIndex,
      backgroundColor,
			isStockVideoStyle = false,
      render,
			height
    } = this.props;

    return (
      <FJModal onHide={this.onHide}
               onShow={this.onShow}
               onShown={onShown}
               onHidden={onHidden}
               visible={visible}
               zIndex={zIndex || 998}
               backgroundColor={backgroundColor ? backgroundColor : 'transparent'}>
        <div className={classNames(styles.container, {[styles.stock_video_container]: isStockVideoStyle})} style={{width: width, height: height}}>
          { this.props.children }
          { hasOuterTitle ? <div className={styles.modal_title}>{title}</div> : null}
          { hasOuterCloseBtn ? <ModalClose onClick={onCancel} /> : null}
          { hasInnerCloseBtn ? <ModalInnerClose onClick={onCancel} /> : null}
          { hasInnerTitle ? <div className={styles.modal_inner_title}>{title}</div> : null}
          { render && render(visible)}
        </div>
      </FJModal>
    );
  }
}

export default FJCommonModal;
